import { useMediaQuery } from 'react-responsive';

import { BREAKPOINT_VALUES } from '../globals/globals.js';

const {
	MOBILESMALL,
	MOBILELARGE,
	XSMALL,
	SMALL,
	MEDIUM,
	XMEDIUM,
	LARGE,
} = BREAKPOINT_VALUES;

export const useIsBelowXSmallOnly = () => {
	return useMediaQuery({ maxWidth: XSMALL });
};

export const useIsXSmallOnly = () => {
	return useMediaQuery({ minWidth: XSMALL, maxWidth: SMALL - 1 });
};

export const useIsXSmallAndAbove = () => {
	return useMediaQuery({ minWidth: XSMALL });
};

export const useIsBelowMobileSmallOnly = () => {
	return useMediaQuery({ maxWidth: MOBILESMALL - 1 });
};

export const useIsBelowMobileLargeOnly = () => {
	return useMediaQuery({ maxWidth: MOBILELARGE - 1 });
};

export const useIsMobileLargeAndAbove = () => {
	return useMediaQuery({ minWidth: MOBILELARGE });
};

export const useIsBelowSmallOnly = () => {
	return useMediaQuery({ maxWidth: SMALL - 1 });
};

export const useIsSmallOnly = () => {
	return useMediaQuery({ minWidth: SMALL, maxWidth: MEDIUM });
};

export const useIsSmallAndAbove = () => {
	return useMediaQuery({ minWidth: SMALL });
};

export const useIsBelowMediumOnly = () => {
	return useMediaQuery({ maxWidth: MEDIUM - 1 });
};

export const useIsMediumOnly = () => {
	return useMediaQuery({ minWidth: MEDIUM, maxWidth: LARGE - 1 });
};

export const useIsMediumAndAbove = () => {
	return useMediaQuery({ minWidth: MEDIUM });
};

export const useIsBelowXMediumOnly = () => {
	return useMediaQuery({ maxWidth: XMEDIUM - 1 });
};

export const useIsXMediumAndAbove = () => {
	return useMediaQuery({ minWidth: XMEDIUM });
};

export const useIsBelowLargeOnly = () => {
	return useMediaQuery({ maxWidth: LARGE - 1 });
};

export const useIsLargeAndAbove = () => {
	return useMediaQuery({ minWidth: LARGE });
};

export const useIsBetweenSmallAndLarge = () => {
	return useMediaQuery({ minWidth: SMALL, maxWidth: LARGE - 1 });
};

export const useIsBetweenXSmallAndMedium = () => {
	return useMediaQuery({ minWidth: XSMALL, maxWidth: MEDIUM - 1 });
};
